import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice LCM - Plus petit commun multiple";
const DESCRIPTION =
  "Calculatrice LCM - Plus petit commun multiple pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "lcm plus petit commun multiple, calculatrice lcm plus petit commun multiple, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/lcm-calculator/";
function LCMCalculator() {
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const gcd = (a, b) => {
    return b === 0 ? a : gcd(b, a % b);
  };
  const lcm = (a, b) => {
    return Math.abs(a * b) / gcd(a, b);
  };
  const handleCalculate = () => {
    try {
      if (!num1 || !num2) {
        setError("Veuillez entrer deux nombres");
        setResult(null);
        return;
      }
      const number1 = parseInt(num1);
      const number2 = parseInt(num2);
      if (number1 === 0 || number2 === 0) {
        setError("Les nombres ne peuvent pas être 0");
        setResult(null);
        return;
      }
      const lcmResult = lcm(number1, number2);
      setResult(lcmResult);
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice LCM vous aide à trouver rapidement le plus petit commun multiple
                  (LCM) de deux nombres ou plus. C'est utile pour résoudre les problèmes mathématiques
                  impliquant les fractions et les multiples.
                </p>
                <p>
                  <strong>Le LCM (Plus Petit Commun Multiple)</strong> est le plus petit nombre positif
                  qui est un multiple de deux nombres ou plus.
                </p>
                <ul>
                  <li>Calcul rapide du PPCM</li>
                  <li>Utile pour les calculs avec fractions</li>
                  <li>Support pour les nombres positifs</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Premier nombre
                      </label>
                      <input
                        type="number"
                        value={num1}
                        onChange={(e) => setNum1(e.target.value)}
                        placeholder="Entrez le premier nombre"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Deuxième nombre
                      </label>
                      <input
                        type="number"
                        value={num2}
                        onChange={(e) => setNum2(e.target.value)}
                        placeholder="Entrez le deuxième nombre"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer LCM                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        LCM de {num1} et {num2} = <strong>{result}</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce que le PPCM ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le PPCM (Plus Petit Commun Multiple) est le plus petit nombre
                        qui est un multiple commun de deux nombres ou plus.
                        Par exemple : PPCM(4, 5) = 20, PPCM(6, 8) = 24.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Comment calculer le PPCM</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Par factorisation : 12 = 2² × 3, 18 = 2 × 3².
                        On prend la puissance maximale de chaque facteur : 2² × 3² = 36.
                        Donc PPCM(12, 18) = 36.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Importance du PPCM</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Le PPCM est utilisé pour trouver le dénominateur commun de fractions,
                        résoudre des problèmes de planification temporelle et synchroniser
                        des composants en ingénierie.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default LCMCalculator;
